import CopyTo from './CopyTo';

export default CopyTo;
